/**
 * useSparklineData — Extracts close prices from price history for sparkline rendering.
 *
 * Composes usePriceHistory to get 24 data points at 1H interval,
 * then extracts just the close prices as a number array.
 *
 * Story 8.4 — Task 4
 */

import { usePriceHistory } from "./use-price-history";

export function useSparklineData(tokenId: string) {
	const { data, isLoading } = usePriceHistory(tokenId, "1H");

	const sparklineData = data?.data?.map((candle) => candle.close);

	return {
		data: sparklineData && sparklineData.length >= 2 ? sparklineData : undefined,
		isLoading,
	};
}
